<template>
<!-- contents -->
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <skp-breadcrumbs :setMenuId='myBugReportMenuId' @page-title="val => pageTitle = val" />
        <!-- //breadcrumbs -->
        <h2 class="pg_title">{{ pageTitle }}</h2>
        <!-- //contents_head -->

        <div class="view_cont">
            <dl class="view_subject">
                <dt class="subject">
                    <em v-if="detail.IMPORTANCE_YN === 'Y'" class="textcolor_important">[{{ $t('FIELD.GLOBAL.IMPORTANT') }}]</em>
                    <em v-else-if="detail.MUST_READ_YN === 'Y'" class="textcolor_must">[{{ $t('FIELD.GLOBAL.MUSTREAD') }}]</em>
                    {{ convertHtml(detail.KNOWLEDGE_TITLE) | refTitle }}
                </dt>
            </dl>

            <div class="view_qna_desc">
                <dl>
                    <dt>
                        <span class="item_status">{{ $t('FIELD.GLOBAL.REGISTERED.BY') }}</span>
                        <span class="item_name">{{ bugDetail.REG_USER_NM }}</span>
                        <span class="item_date">{{ bugDetail.REG_DT }}</span>
                    </dt>
                    <dd>
                        {{ convertHtml(bugDetail.REPORT_DESC) }}
                    </dd>
                </dl>
            </div>

            <!-- See the Content -->
            <section class="see_content_wrap" v-if="!isLoading">
                <p class="sec_title"><em>{{ $t('TITLE.BUGREPORT.CONTENT') }}</em></p>

                <dl class="dl_view">
                    <dt>{{ $t('FIELD.GLOBAL.CATEGORY') }}</dt>
                    <dd>
                        {{ detail.PRD_CATEGORY_NM1 }}
                        <template v-if="typeof detail.PRD_CATEGORY_NM2 !== 'undefined'">&gt; {{ detail.PRD_CATEGORY_NM2 }}</template>
                        <template v-if="typeof detail.PRD_CATEGORY_NM3 !== 'undefined'">&gt; {{ detail.PRD_CATEGORY_NM3 }}</template>
                    </dd>
                </dl>
                <dl class="dl_view">
                    <dt>{{ $t('FIELD.GLOBAL.REGISTERED.BY') }}</dt>
                    <dd>{{ detail.REG_USER }}</dd>
                    <dt>{{ $t('FIELD.GLOBAL.REGISTER.DATE') }}</dt>
                    <dd>{{ detail.REG_DT }}</dd>
                </dl>
                <dl class="dl_view">
                    <dt>{{ $t('FIELD.GLOBAL.MODIFY.USER') }}</dt>
                    <dd>{{ detail.MODF_USER }}</dd>
                    <dt>{{ $t('FIELD.GLOBAL.LASTMODIFY.DATE') }}</dt>
                    <dd>{{ detail.MODF_DT }}</dd>
                </dl>

                <!-- 200420수정 S -->
                <!-- SCMS Contents 의 경우, Symptom 및 Serial 등 추가 항목 -->
                <table v-if="isSCMS" class="data_table_ty2 mb-20">
                    <colgroup>
                        <col width="20%">
                        <col width="30%">
                        <col width="20%">
                        <col width="*">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th class="text_left">{{ $t('FIELD.GLOBAL.SYMPTOM') }}</th>
                            <td>
                                <ul class="in_dotlist" v-if="symptomList.length === 0">
                                    <li>&nbsp;</li>
                                </ul>
                                <ul class="in_dotlist" v-else v-for="symptom in symptomList">
                                    <li>{{ symptom.NAME }}</li>
                                </ul>
                            </td>
                            <!-- TODO Manufacture date ? -->
                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.MANUFACTURE') }}</th>
                            <td>
                                <ul class="in_dotlist" v-if="serialList.length === 0">
                                    <li>&nbsp;</li>
                                </ul>
                                <ul class="in_dotlist" v-else v-for="serial in serialList">
                                    <li>{{ serial.SERIAL_S }} ~ {{ serial.SERIAL_E }}</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.GUIDETYPE') }}</th>
                            <td>{{ getGuideTypeName }}</td>
                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.DEFECTTYPE') }}</th>
                            <td>{{ getDefectTypeName }}</td>
                        </tr>
                    </tbody>
                </table>
                <!-- //200420수정 E -->

                <div class="tab_wrap mt-30">
                    <ul class="tab_menu_02 tab_menus">
                        <li class="on" @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.GLOBAL.DESCRIPTION') }}</a></li>
                        <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.GLOBAL.MODEL.LIST') }}</a></li>
                        <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.PARTSLISTS') }}</a></li>
                        <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.VERHISTORY') }}</a></li>
                    </ul>
                    <div class="tab_contents">
                        <div class="tab_cont" v-html="detail.KNOWLEDGE_DESC" />
                        <div class="tab_cont">
                            <model-grid
                                v-if="reloadModel"
                                :gridId="modelGridId"
                                :ref="modelGridId"
                                :data="modelList"
                                :columns="modelColumns"
                                :options="options"
                                :pageOptions="pageOptions"
                                :isTotalCount="true"
                            />
                        </div>
                        <div class="tab_cont">
                            <parts-grid
                                v-if="reloadParts"
                                :gridId="partsGridId"
                                :ref="partsGridId"
                                :data="partsList"
                                :columns="partsColumns"
                                :options="options"
                                :pageOptions="pageOptions"
                                :isTotalCount="true"
                            />
                        </div>
                        <div class="tab_cont">
                            <!-- Version Tab -->
                            <table class="data_table">
                                <colgroup>
                                    <col width="15%">
                                    <col width="15%" class="pc_only">
                                    <col width="25%" class="pc_only">
                                    <col width="*">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>{{ $t('FIELD.GLOBAL.VERSION') }}</th>
                                        <th class="pc_only">{{ $t('FIELD.GLOBAL.DATE') }}</th>
                                        <th class="pc_only">{{ $t('FIELD.GLOBAL.EDITOR') }}</th>
                                        <th>{{ $t('FIELD.GLOBAL.DETAILS') }}</th>
                                    </tr>
                                </thead>
                                <tbody class="text_center">
                                    <tr v-if="versionList.length > 0" v-for="(version, idx) in versionList">
                                        <td>Ver.{{ version.VERSION_NO }}</td>
                                        <td class="pc_only">{{ version.MODF_DT }}</td>
                                        <td class="pc_only">{{ version.MODF_USER }}</td>
                                        <td class="text_left">
                                            <a  v-if="idx > 0"
                                                href="javascript:"
                                                class="over_line"
                                                @click="seeDetailPop(version.KNOWLEDGE_ID, version.VERSION_NO)"
                                            >
                                                {{ convertHtml(version.MODF_REASON) }}
                                            </a>
                                            <template v-else>{{ convertHtml(version.MODF_REASON) }}</template>
                                            <a  v-if="typeof(version.APPROVAL_ID) !== 'undefined'"
                                                href="javascript:"
                                                class="txt_link"
                                                @click="seeApprovalHistoryPop(version.APPROVAL_ID)"
                                            >
                                                {{ $t('FIELD.GLOBAL.ETC.001') }}
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div v-if="isPrevious" class="btn_wrap text_right pt-10">
                                <a href="javascript:" class="txt_link" :title="$t('FIELD.KNOWLEDGE.SEE.PREVIOUS')" @click="seePrevPop">{{ $t('FIELD.KNOWLEDGE.SEE.PREVIOUS') }}</a>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- Attachment -->
                <innorix-download
                    v-if="attach.length > 0"
                    :uploadId="uploadId"
                    :serviceType="serviceType"
                    :attachList="attach"
                />
                <!-- //Attachment -->
            </section>

            <div class="btn_wrap topLine">
                <a href="javascript:" class="btn_white size_full" title="" @click="btnList">{{ $t('BUTTON.GLOBAL.LIST') }}</a>
                <div v-if="!isLoading && !isClose" class="btn_right pc_only">
                    <a href="javascript:" class="btn_white" title="" @click="btnExpire">{{ $t('BUTTON.GLOBAL.EXPIRE') }}</a>
                    <a href="javascript:" class="btn_white" title="" @click="btnCloseBug">{{ $t('BUTTON.BUGREPORT.CLOSE.BUG') }}</a>
                    <a href="javascript:" class="btn_white" title="" @click="btnModify">{{ $t('BUTTON.GLOBAL.MODIFY') }}</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- contents -->
</template>
<script>
import Vue                                  from 'vue';
import qs                                   from 'query-string';
import axios                                from 'axios';
import _                                    from 'lodash';
import { mapGetters, mapActions }           from 'vuex';
import store                                from '@/vuex/store';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import CrossEditorViewer                    from '~c/CrossEditorViewer';
import InnorixDownload                      from '~c/InnorixDownload';
import KnowledgeModelGrid                   from '~vb/knowledge/popup/KnowledgeModelGrid';
import KnowledgePartsGrid                   from '~vb/knowledge/popup/KnowledgePartsGrid';
import KnowledgePreviousPopup               from '~vb/knowledge/popup/KnowledgePreviousPopup';
import KnowledgeVersionDetailPopup          from '~vb/knowledge/popup/KnowledgeVersionDetailPopup';

import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';

// Service Bulletin, Repair Tip, Repeated Repair Tip
const SCMS_CONTENTS_CD = MenuUtil.getScmsContents;

// get Bug Report Infomation
const fetchBugReportDetail = bugReportId => axios.post(
    `${SDLUtil.API_URL}/basis/myKnowledge/myKnowledge/bugReport/bugReportDetail.skp`,
    qs.stringify({ BUG_REPORT_ID: bugReportId }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'BugReportDetail',
    props: {
        bugReportId:    { required: true },
    },
    data() {
        return {
            myBugReportMenuId: 'LEFT_0000000072',

            isLoading : true,
            isClose: false,
            pageTitle: '',
            window: { width: 0, height: 0 },

            processStep: 0,
            boardId: '',
            knowledgeId: '',
            bugDetail: {},

            strSymptom: [],
            modelList: [],
            modelColumnName: [],
            partsList: [],
            symptomList: [],
            serialList: [],
            satisfaction: [],
            attachImg: [],
            detail: {},
            attach: [],
            verifyList: [],
            versionList: [],
            isPrevious: false,
            isFavorite: false,
            isRepair: false,
            isSCMS: false,

            reloadModel: false,
            reloadParts: false,

            editorId: 'editor_' + String(this.bugReportId),

            modelGridId: 'mdlGrid_' + String(this.bugReportId),
            modelColumns: [],

            partsGridId: 'ptsGrid_' + String(this.bugReportId),
            partsColumns: [],

            options: {
                scrollY: true,
                minBodyHeight: 80,
                bodyHeight: 265
            },
            pageOptions: {
                useClient: true,
                perPage: 20
            },

            uploadId: 'download_' + String(this.bugReportId),
            serviceType: 'common'

        }
    },
    computed: {
        ...mapGetters({
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
            menus: 'getMenus',
            params: 'getParams',
        }),
        isMobile() {
            let loginUser = SDLUtil.getLoginedUserInfo() || { device : 'desktop' };
            return ((loginUser !== null) && (loginUser.device == 'desktop') && this.window.width > 1024) ? true : false
        },
        getUserRole()           { return this.userRoles || []; },
        getUserCorpCd()         { return this.userCorpCd || ''; },
        getKnowledgeId()        { return this.knowledgeId; },
        getBugReportId()        { return this.bugReportId || this.bugDetail.BUG_REPORT_ID || ''; },
        getBoardId()            { return this.boardId; },
        getEditorId()           { return this.editorId; },
        getBoardCreationYN()    { return this.params.creationYn || 'N'; },
        getDefectTypeName() {
            let defectType = this.detail.DEFECT_TYPE || '',
                defectTypeName = { "M":"Common", "C":"Call", "R":"Repair" };

            if(!SDLUtil.isNull(defectType)) {
                return defectTypeName[defectType];
            } else {
                return  '-';
            }
        },
        getGuideTypeName() {
            let guideType = this.detail.GUIDE_TYPE || '',
                guideTypeName = {"H":"H/W", "S":"S/W", "M":"Mechanical", "A":"Accessory", "I":"Info Sharing", "E":"Others"};

            if(!SDLUtil.isNull(guideType)) {
                return guideTypeName[guideType];
            } else {
                return  '-';
            }
        }
    },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
        'model-grid'        : KnowledgeModelGrid,
        'parts-grid'        : KnowledgePartsGrid,
        'cross-editor'      : CrossEditorViewer,
        'innorix-download'  : InnorixDownload
    },
    methods: {
        async initLoad() {
            SDLUtil.showLoadingBar(true);
            return await fetchBugReportDetail(this.bugReportId)
                .then(res => {
                    return res.data;
                })
                .catch(err => {
                    const data = err.data;
                    SDLUtil.alert({
                        title: 'TITLE.WARNING.TITLE',
                        msg: data.error.message,
                        onOkEvt: () => {
                            return this.$router.push({ name: "MyBugReport" });
                        }
                    });

                    SDLUtil.showLoadingBar(false);
                });
        },
        // 브라우저 리사이징 이벤트
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        changeTab(e) {
            let tabIndex = $('.tab_menus > li > a').index(e.target);
            this.processStep = tabIndex;

            if( $(e.target).hasClass('on') == true){
                $(e.target).parents('li').removeClass('on');
                $('.tab_wrap .tab_cont').hide();

            } else {
                $('.tab_wrap li').removeClass('on');
                $('.tab_wrap .tab_cont').hide();
                $(e.target).parents('li').addClass('on');
                $('.tab_wrap .tab_cont').eq(tabIndex).show();

                if(this.processStep === 1) {
                    this.modelList = this.modelList;
                    this.reloadModel = true;
                    this.getDynamicCols('MODEL');

                } else if(this.processStep === 2) {
                    this.partsList = this.partsList;
                    this.reloadParts = true;
                    this.getDynamicCols('PARTS');

                } else {
                    this.reloadModel = false;
                    this.reloadParts = false;
                }
            }

            EventBus.$emit('grid-refresh');
        },
        btnAuth() {
            let isAuth = false;
            if(
                SDLUtil.isNull(this.detail.CTTID) &&
                this.userRoles.find(
                    r => r === `${constants.SYSTEM_ADMIN}`
                      || r === `${constants.GBM_ADMIN}`
                      || r === `${constants.RHQ_ADMIN}`
                      || r === `${constants.SUB_ADMIN}`
                      /*
                        /basis/knowledge/symptom/Detail.jsp line 541
                        Environment admin 권한에 대해서도 수정 할 수 있는 권한을 부여하자
                        ( 전제조건: Environment 환경 컨텐츠 국한되어야 하는데... ) SEA 의 경우 ROLE 2200 은 환경컨텐츠가 아님.
                      */
                      || ( r === `${constants.ENV_ADMIN}` && this.userCorpCd !== 'C310' )
                )
            ) {
                isAuth = true;
            }

            return isAuth;
        },
        // 그리드 컬럼 percent resize 용
        getDynamicCols(type = '') {
            let colType = type;
            if(SDLUtil.isNull(type)) {
                if(this.processStep === 1) {
                    colType = 'MODEL';

                } else if(this.processStep === 2) {
                    colType = 'PARTS';
                };
            }

            if(SDLUtil.isMobile()) {
                if(colType === 'MODEL') {
                    return [
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'), name: 'CDMODEL', align: 'center', resizable: true, sortable: true,
                                    filter: { type: 'text', showApplyBtn: true, showClearBtn: true, state: { code: 'contain'} } },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL'), name: 'NMMODEL', align: 'center', resizable: true, sortable: true },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MARKETINGNAME'), name: 'MAKETNM', align: 'center', resizable: true, sortable: true },
                        { header: 'CDCOMPANY', name: 'CDCOMPANY', hidden: true },
                        { header: 'CDGBM', name: 'CDGBM', hidden: true },
                    ];

                } else {
                    return [
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.CODE'), name: 'PARTS_CODE', align: 'center', resizable: true, sortable: true },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.TYPE'), name: 'PARTS_TYPE', align: 'center', resizable: true, sortable: true }
                    ];
                }

            } else {
                if(colType === 'MODEL') {
                    return [
                        /* 2020.06.26 Subsidiary 컬럼 삭제 */
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'), name: 'CDMODEL', align: 'center', width: this.getColumnSize(20), resizable: true, sortable: true,
                                    filter: { type: 'text', showApplyBtn: true, showClearBtn: true, state: { code: 'contain'} } },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL'), name: 'NMMODEL', align: 'center', width: this.getColumnSize(25), resizable: true, sortable: true },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MARKETINGNAME'), name: 'MAKETNM', align: 'center', width: this.getColumnSize(25), resizable: true, sortable: true },
                        { header: 'CDCOMPANY', name: 'CDCOMPANY', hidden: true },
                        { header: 'CDGBM', name: 'CDGBM', hidden: true },
                    ];

                } else {
                    return [
                        /* 2020.04.06 Parts Name 컬럼 삭제 */
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.CODE'), name: 'PARTS_CODE', align: 'center', width: this.getColumnSize(30), resizable: true, sortable: true },
                        { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.TYPE'), name: 'PARTS_TYPE', align: 'center', width: this.getColumnSize(25), resizable: true, sortable: true }
                    ];
                };
            };
        },
        getColumnSize(size) {
            if(isNaN(Number(size))) { return 0; }
            let gridWrapSize = document.getElementsByClassName('tab_cont').length ? document.getElementsByClassName('tab_cont')[this.processStep].clientWidth - 16 : 1000;
            return Math.floor((gridWrapSize - 50) / (100 / size));
        },
        setGridResizeColumn(e) {
            // 그리드 다이나믹 컬럼
            if(this.processStep === 1) {
                EventBus.$emit('model-grid-set-column', this.getDynamicCols());

            } else if(this.processStep === 2) {
                EventBus.$emit('parts-grid-set-column', this.getDynamicCols());
            }
        },
        // 버전 상세 보기 팝업
        seeDetailPop(knowledgeId, knowledgeVer) {
            Vue.$log.info("▶ KnowledgeDetailPopup.vue See Detail Popup => ", knowledgeId, knowledgeVer);
            SDLUtil.show(
                KnowledgeVersionDetailPopup,
                {
                    KNOWLEDGE_ID: knowledgeId,
                    VERSION_NO: knowledgeVer
                },
                { height: 'auto' }
            );
        },
        // 결재 이력 보기 팝업
        seeApprovalHistoryPop(approvalId) {
            Vue.$log.info("▶ KnowledgeDetailPopup.vue See Approval History Popup => ", approvalId);
            SDLUtil.show(
                ApprovalHistoryPopup,
                {
                    approvalId: approvalId
                },
                { height: 'auto' }
            );
        },

        // 복제 이전 버전 보기
        seePrevPop() {
            Vue.$log.info("▶ KnowledgeDetailPopup.vue See Previous Popup");
            let prevId = this.detail['PREVIOUS_ID'] || '';
            if(!StringUtil.isNull(prevId)) {
                SDLUtil.show(
                    KnowledgePreviousPopup,
                    {
                        KNOWLEDGE_ID: prevId
                    },
                    { height: 'auto' }
                );
            }
        },
        btnList() {
            return this.$router.push({ name: 'MyBugReport' });
        },
        btnExpire() {
            SDLUtil.showLoadingBar(true);
            SDLUtil.confirm({
                title: "TITLE.WARNING.TITLE",
                msg: 'MESSAGE.DATA.EXPIRE.CONFIRM',
                onOkEvt: () => {
                    return  axios.post(
                                `${SDLUtil.API_URL}/basis/myKnowledge/myKnowledge/register/expire.skp`,
                                qs.stringify({ KNOWLEDGE_ID: this.getKnowledgeId, boardTypeRoot: this.getUserCorpCd }),
                                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                            )
                            .then(res => {
                                let data = res.data;
                                if(data.msg) {
                                    SDLUtil.alert({
                                        title: 'FIELD.GLOBAL.PROGRESS.COMPLETE',
                                        msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                        onOkEvt: () => {
                                            this.btnList();
                                        }
                                    });
                                }
                            })
                            .catch(err => {
                                SDLUtil.errorAlert(err);
                            });
                }
            });
            SDLUtil.showLoadingBar(false);
        },
        btnCloseBug() {
            SDLUtil.showLoadingBar(true);
            SDLUtil.confirm({
                msg: 'MESSAGE.BUGREPORT.CLOSE.BUG',
                onOkEvt: () => {
                    return  axios.post(
                                `${SDLUtil.API_URL}/basis/myKnowledge/myKnowledge/bugReport/settle.skp`,
                                qs.stringify({ BUG_REPORT_ID: this.getBugReportId }),
                                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                            )
                            .then(res => {
                                let data = res.data;
                                if(data.msg) {
                                    SDLUtil.alert({
                                        title: 'FIELD.GLOBAL.PROGRESS.COMPLETE',
                                        msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                        onOkEvt: () => {
                                            this.btnList();
                                        }
                                    });
                                }
                            })
                            .catch(err => {
                                SDLUtil.errorAlert(err);
                            });
                }
            });
            SDLUtil.showLoadingBar(false);
        },
        btnModify() {
            Vue.$log.info('▶ BugReportDetail.vue modify event. =>', this.getBugReportId, this.getKnowledgeId);
            store.commit('POPUP_PARAMS', {
                knowledgeId: this.getKnowledgeId,
                bugReportId: this.getBugReportId,
                isModify: true,
                isBugReport: true,
            });

            let linkUrl = MenuUtil.getRedirectUrl('/basis/myKnowledge/myKnowledge/register/registerForm');
            const detailPop = SDLUtil.openLegacyWindowPopup({
                url: linkUrl,
                title: SDLUtil.getMsgProp('TITLE.KNOWLEDGE.DETAIL'),
                w: 1366,
                h: 768
            });

            // 팝업이 닫히면 자동으로 리스트로 이동
            let self = this,
                popTimer = window.setInterval(function() {
                if (detailPop.closed !== false) { // !== is required for compatibility with Opera
                    window.clearInterval(popTimer);
                    self.btnList();
                }
            }, 200);
        },
        convertHtml(str) {
            return SDLUtil.convertHtml(str);
        }
    },
    created() {
        Vue.$log.info('▶ BugReportDetail.vue created. / bugReportId :', this.getBugReportId);
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        this.initLoad().then(res => {
            Vue.$log.info("▶ BugReportDetail.vue Response => ", res);
            this.bugDetail = res.bugDetail.rowData[0];
            this.symptomList = res.symptomList.rowData;
            this.serialList = res.serialList.rowData;
            this.modelList = res.modelList.rowData;
            this.modelColumnName = res.modelList.columnName;
            this.satisfaction = res.satisfaction.rowData;
            this.attachImg = res.attachImg.rowData;
            this.detail = res.detail.rowData[0];
            this.attach = res.attach.rowData;
            this.verifyList = res.verifyList.rowData;
            this.versionList = res.version.rowData;
            this.knowledgeId = this.detail.KNOWLEDGE_ID;

            this.modelColumns = this.getDynamicCols('MODEL');
            this.partsColumns = this.getDynamicCols('PARTS');

            // 즐겨찾기 확인
            try{
                if(this.detail['FAVORITE'] == 0) {
                    this.isFavorite = false;
                } else {
                    this.isFavorite = true;
                };

            } catch(e) {
                this.isFavorite = false;
            };

            // 이전 버전 존재 확인
            try {
                if(SDLUtil.isNull(this.detail['PREVIOUS_ID'])) {
                    this.isPrevious = false;
                } else {
                    this.isPrevious = true;
                };

            } catch(e) {
                this.isPrevious = false;
            };

            // Closing 여부
            if(!SDLUtil.isNull(this.bugDetail)) {
                this.isClose = (this.bugDetail['STATUS'] === 'C') ? true : false;
            }

            // SCMS Knowledge 인지 확인
            let menuGroupDetailCd = this.detail['MENU_GROUP_DETAIL_CD'] || '';
            if( _.includes(SCMS_CONTENTS_CD, menuGroupDetailCd) ) {
                if(menuGroupDetailCd === 'RT') this.isRepair = true;
                this.isSCMS = true;
            };

            SDLUtil.showLoadingBar(false);
            this.isLoading = false;
        });
    },
    mounted() {
        //
    },
    beforeDestroy(){
        // Vue.$log.info('▶ BugReportDetail.vue beforeDestroy.');
        window.removeEventListener('resize', this.handleResize);
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/myKnowledge/bugReport/BugReportDetail.vue